module.exports = "/_next/static/images/memphis-tn-69b18f557c38a8b2097637d6eaaf9f23.jpg";